import { ICreateExpenseRequestParams } from "Dashboard/scenes/Expenses/domain/ICreateExpenseRequestParams";
import {
  Control,
  Controller,
  FieldErrorsImpl,
  UseFormGetValues,
  UseFormHandleSubmit,
  UseFormRegister,
  UseFormReset
} from "react-hook-form";
import classes from "../../../../../../components/Popover/popover.module.scss";
import ProjectSelect from "Dashboard/scenes/Projects/components/ProjectSelect";
import { styles } from "components/Popover/popoverSelectStyle";
import DatePicker from "react-datepicker";
import { FormatDateIso } from "utils/dateUtils";
import { expensesService } from "Dashboard/scenes/Expenses/services/expenses.service";
import { getExpensesList, setNewExpensePopover } from "../main.slice";
import { toast } from "react-toastify";
import { useAppDispatch } from "hooks/hooks";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faLongArrowAltDown } from "@fortawesome/free-solid-svg-icons";
import classesExpense from "../../../styles/NewExpensePopover.module.scss";

interface IProps {
  handleSubmit: UseFormHandleSubmit<ICreateExpenseRequestParams>;
  register: UseFormRegister<ICreateExpenseRequestParams>;
  control: Control<ICreateExpenseRequestParams, any>;
  getValues: UseFormGetValues<ICreateExpenseRequestParams>;
  errors: Partial<FieldErrorsImpl<ICreateExpenseRequestParams>>;
  reset: UseFormReset<ICreateExpenseRequestParams>;
}

const NewExpensePopover = (props: IProps) => {
  const dispatch = useAppDispatch();

  const {
    handleSubmit,
    register,
    control,
    getValues,
    errors,
    reset,
  } = props;

  const onSubmit = async (data: ICreateExpenseRequestParams) => {
    try {
      await expensesService.createExpense(data);
      dispatch(getExpensesList());
      close();
      toast.success("Trošak je uspesno dodat.");
    } catch (err) {
      console.error(err);
    }
  };

  const close = () => {
    dispatch(setNewExpensePopover({ isOpen: false }));
    reset();
  };

  return (
    <form
      onSubmit={handleSubmit(onSubmit)}
      className={`${classesExpense.newExpensePopover} ${classes.basicPopover}`}
    >
      <div className={classes.row}>
        <div className={`${classes.col} ${classes.rowDir}`}>
          <label className={classes.mr5}>naziv troška</label>
          <input type="text" className={`${classes.itemBorder}
            ${errors.title ? classes.itemError : ""}`}
            {...register("title", { required: true })}
          />
        </div>
      </div>

      <div className={classes.row}>
        <div className={`${classes.col} ${classes.rowDir}
          ${errors.projectId ? classes.itemError : ""}`}>
          <label className={classes.mr5}>projekat</label>
          <Controller
            name="projectId"
            control={control}
            defaultValue={undefined}
            rules={{
              required: true,
            }}
            render={({ field: { onChange } }) => (
              <ProjectSelect
                value={getValues("projectId")}
                error={errors.projectId}
                customStyles={styles.customStyleClassic}
                onChange={onChange}
              />
            )}
          />
        </div>
      </div>

      <div className={classes.row}>
        <div className={`${classes.col} ${classes.rowDir}`}>
          <label className={classes.mr5}>datum</label>
          <div>
            <Controller
              control={control}
              name="date"
              defaultValue={undefined}
              rules={{ required: true }}
              render={({ field: { onChange, value } }) => (
                <DatePicker
                  className={`${classes.dateItem} ${classes.itemBorder}
                  ${classes.solidBorder} ${errors.date ? classes.itemError : ""}`}
                  onChange={(date) => {
                    onChange(date ? FormatDateIso(date) : undefined);
                  }}
                  dateFormat="dd.MM.yyyy"
                  showMonthDropdown
                  showYearDropdown
                  selected={value ? new Date(value) : null}
                />
              )}
            />
          </div>
        </div>
      </div>

      <div className={classes.row}>
        <div className={classes.buttons}>
          <button className={classes.iconButton} type="submit">
            <FontAwesomeIcon icon={faLongArrowAltDown} className={classes.icon} />
          </button>
        </div>
      </div>
    </form>
  );
};

export default NewExpensePopover;
